import React, { useEffect, useState } from "react";
import TablePagination from "../../../components/Table/TablePagination";
import { Texts } from "../../GeneralSettingPage/orderTimeFrame/OrderPeriod.styles";
import color from "../../../resource/color";
import { Col, Progress, Row, Tag } from "antd";
import Text from "../../../components/Text/Text";
import {
  InfoCircleFilled,
  SearchOutlined,
  SyncOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import icon from "../../../resource/icon";
import Input from "../../../components/Input/Input";
import useSorting from "../../../hook/useSorting";
import SortFieldCustom from "../../../components/SortFieldTable/SortFieldCustom";
import ModalSync from "../../../components/Modal/ModalSync";
import { useNavigate } from "react-router-dom";
import { getShopCreditLimit, getShopDetail } from "../../../datasource/CreditLimitDatasource";
import {
  AllShopCreditLimitEntity_INIT,
  ShopDetailEntity_INIT,
  type AllShopCreditLimitEntity,
  type ShopDetailEntity,
} from "../../../entities/CreditLimitEntity";
import { numberFormatter } from "../../../utility/Formatter";
import ZoneSelect from "../../../components/Select/ZoneSelect";
import NewModalInfoCredit from "../../../components/Modal/NewModalInfoCredit";

export const AllCreditTabNew = ({ callBackData }: { callBackData: (value: any) => void }) => {
  const companyCode = JSON.parse(localStorage.getItem("company")!);
  const [infoCreditModal, setInfoCreditModal] = useState<{
    open: boolean;
    cusComId: any;
  }>({ open: false, cusComId: null });
  const [syncData, setSyncData] = useState(false);
  const [searchText, setSearchText] = useState<string | undefined>(undefined);
  const [searchZone, setSearchZone] = useState<string | undefined>(undefined);
  const [page, setPage] = useState<number>(1);
  const { sortField, sortDirection, handleSortChange } = useSorting();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<AllShopCreditLimitEntity>(AllShopCreditLimitEntity_INIT);
  const [shopDetail, setShopDetail] = useState<ShopDetailEntity>(ShopDetailEntity_INIT);
  const [cusCompId, setCusCompId] = useState<number>(0);
  const [customerNo, setCustomerNo] = useState<string>("");

  const getShopCredit = async () => {
    setLoading(true);
    try {
      await getShopCreditLimit(
        companyCode?.companyCode,
        searchText,
        searchZone,
        sortField,
        sortDirection,
        page,
        10,
      ).then((res) => {
        setData(res);
        callBackData(res);
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getShopCredit();
  }, [searchText, sortDirection, page, searchZone]);

  const columns: any = [
    {
      title: "รหัสร้านค้า",
      dataIndex: "customerNo",
      key: "customerNo",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts size='16'>{value}</Texts>
            </>
          ),
        };
      },
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "25%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts size='16'>{value}</Texts>
              <Texts style={{ color: color.background4 }}>{row.taxNo}</Texts>
            </>
          ),
        };
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <Texts size='16'>{value}</Texts>
              <Texts style={{ color: color.background4 }}>{row.province}</Texts>
            </>
          ),
        };
      },
    },
    // {
    //   title: () => (
    //     <SortFieldCustom
    //       title='วงเงินที่ใช้ไป'
    //       sortDirection={sortField === "creditUsed" ? sortDirection : undefined}
    //       onSortChange={() => handleSortChange("creditUsed")}
    //     />
    //   ),
    //   dataIndex: "creditUsed",
    //   key: "creditUsed",
    //   render: (value: string, row: any) => {
    //     return (
    //       <Row
    //         gutter={[16, 16]}
    //         style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
    //       >
    //         <Col span={8}>
    //           <ProgressCircle
    //             percent={numberFormatter(row.perCentCreditUsed, 0)}
    //             size={80}
    //             textColor={color.Grey}
    //             textSize={12}
    //             fontWeight={700}
    //             customStrokeColor={color.error}
    //           />
    //         </Col>
    //         <Col span={14}>
    //           <Text fontFamily='Sarabun' fontSize={16}>
    //             {numberFormatter(value, 2)}
    //           </Text>
    //           <br />
    //           {row.overCredit && row.overCredit > 0 ? (
    //             <Text fontFamily='Sarabun' fontSize={14} color='error'>
    //               (+ {numberFormatter(row.overCredit, 2)})
    //             </Text>
    //           ) : null}
    //         </Col>
    //       </Row>
    //     );
    //   },
    // },
    {
      title: () => (
        <SortFieldCustom
          title='วงเงินคงเหลือ (฿)'
          sortDirection={sortField === "creditBalance" ? sortDirection : undefined}
          onSortChange={() => handleSortChange("creditBalance")}
        />
      ),
      dataIndex: "creditBalance",
      key: "creditBalance",
      render: (value: string, row: any) => {
        return (
          <>
            <Progress
              strokeColor={color.primary}
              percent={row.percentCreditBalance}
              showInfo={false}
            />
            <Row justify='space-between'>
              <Col>
                <Text color={row.isOverCredit ? "error" : "BK"} fontWeight={600}>
                  {numberFormatter(value, 2)}
                </Text>{" "}
                <Text level={6} color={row.isOverCredit ? "error" : "Text3"}>
                  ({numberFormatter(row.percentCreditBalance, 2)}%)
                </Text>
                <br />
                {row.isOverCredit && (
                  <Tag color={row.isOverCredit ? "error" : "primary"} style={{ border: "none" }}>
                    <Text level={6} color='error' fontWeight={400}>
                      วงเงินเกิน
                    </Text>
                  </Tag>
                )}
              </Col>
              <Col>
                <Text>/{numberFormatter(row.creditLimit, 2)}</Text>
                <InfoCircleFilled
                  style={{ marginLeft: 4, cursor: "pointer" }}
                  onClick={() => {
                    setCusCompId(row.customerCompanyId);
                    setInfoCreditModal({ open: true, cusComId: row.customerCompanyId });
                  }}
                />
              </Col>
            </Row>
          </>
        );
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Row justify='space-evenly'>
              {[
                {
                  icon: <UnorderedListOutlined style={{ color: color["primary"] }} />,
                  onClick: () => navigate(`/order/shop-credit-limit/${row.customerCompanyId}`),
                },
                {
                  icon: <SyncOutlined style={{ color: color["primary"] }} />,
                  onClick: () => {
                    setSyncData(true);
                    setCustomerNo(row.customerNo);
                  },
                },
              ].map(({ icon, onClick }, index) => (
                <Col key={index}>
                  <div
                    className='btn btn-icon btn-light btn-hover-primary btn-sm'
                    onClick={onClick}
                  >
                    <span className='svg-icon svg-icon-primary svg-icon-2x'>{icon}</span>
                  </div>
                </Col>
              ))}
            </Row>
          ),
        };
      },
    },
  ];

  return (
    <div>
      <div style={{ marginTop: "22px" }}>
        <Row justify='start' gutter={[16, 16]} style={{ marginBottom: "32px" }}>
          <Col className='gutter-row' span={6}>
            <Input
              placeholder='ค้นหารหัสร้านค้า / ชื่อร้านค้า / เลขนิติบุคคล'
              suffix={<SearchOutlined />}
              defaultValue={searchText}
              onPressEnter={(e) => {
                const value = (e.target as HTMLTextAreaElement).value;
                setSearchText(value);
                setPage(1);
              }}
              onChange={(e) => {
                const value = (e.target as HTMLInputElement).value;
                if (!value) {
                  setSearchText(undefined);
                  setPage(1);
                }
              }}
            />
          </Col>
          <Col className='gutter-row' span={4}>
            <ZoneSelect
              value={searchZone}
              onChange={(e) => {
                setSearchZone(e);
                setPage(1);
              }}
            />
          </Col>
        </Row>
      </div>
      <TablePagination
        isLoading={loading}
        columns={columns}
        data={data.data || []}
        pagination={{
          current: page,
          pageSize: 10,
          total: data?.count || 0,
          onChange: (page) => {
            setPage(page);
          },
        }}
        onPageChange={(pageNum) => setPage(pageNum)}
        locale={{
          emptyText: (
            <div
              style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                minHeight: 350,
              }}
            >
              <img
                src={icon.emptyHistoryPoint}
                style={{
                  width: 80,
                  height: 90,
                }}
                alt='empty_table'
              />
              <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                ไม่มีรายการร้านค้า
              </Text>
            </div>
          ),
        }}
        scroll={{ x: "max-content" }}
      />
      {infoCreditModal.open && (
        <NewModalInfoCredit
          open={infoCreditModal.open}
          onClose={() => setInfoCreditModal({ open: false, cusComId: null })}
          cusComId={infoCreditModal.cusComId}
        />
      )}
      <ModalSync
        open={syncData}
        onClose={() => {
          setSyncData(false);
          getShopCredit();
        }}
        customerNo={customerNo}
      />
    </div>
  );
};
